var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateTeam } from "../ApiProvider";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { TeamForm } from "./TeamForm";
export var CreateTeam = function () {
    var _a = __read(useState(false), 2), loading = _a[0], setLoading = _a[1];
    var _b = __read(useState(undefined), 2), error = _b[0], setError = _b[1];
    var navigate = useNavigate();
    var onSuccess = function (data) {
        var team = data.data;
        navigate("/teams/".concat(team.id, "/"));
    };
    var onError = function (error) {
        setLoading(false);
        setError(error);
    };
    var mutation = useCreateTeam({
        onMutate: function () { return setLoading(true); },
        onSuccess: onSuccess,
        onError: onError,
    });
    if (loading) {
        return _jsx(Loading, {});
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: !!error, message: "Failed to create team. Please try again.", onClose: function () { return setError(undefined); } }), _jsx(Typography, { variant: "h4", gutterBottom: true, sx: { fontSize: { xs: "1.75rem", sm: "2.125rem" } }, children: "Create Team" }), _jsx(TeamForm, { onSubmit: mutation.mutate })] }));
};
